export default {
  backToHome: 'Zpět na úvod',

  forbiddenTitle: 'Přístup odepřen',
  forbiddenMessage: 'Nemáte oprávnění zobrazit tento zdroj.',

  serverErrorTitle: 'Chyba serveru',
  serverErrorMessage: 'Na naší straně se něco pokazilo. Náš tým byl informován — zkuste to prosím za okamžik znovu.',

  serviceUnavailableTitle: 'Probíhá údržba',
  serviceUnavailableMessage:
    'PixelKey je dočasně mimo provoz kvůli plánované údržbě. Brzy budeme zpět online — děkujeme za vaši trpělivost.',

  notFoundTitle: 'Stránka nenalezena',
  notFoundMessage: 'Stránka, kterou hledáte, neexistuje nebo byla přesunuta. Zkontrolujte adresu URL nebo se vraťte na úvod.',
};
